// extracted by mini-css-extract-plugin
export default {"cardHeader":"cardHeader---k92qo","layout":"layout---GoY7d"};